const getCustomFields = (type, params) => {
    return window.ApiClient.post('/custom-fields/search',
        params, 
        {  
            filters: { 
                related_object: type 
            } 
        }
    );
}

const getAllCustomFields = (type, params) => {
    const fields = [];
    let pagination;
    const fetchFields = async (offset) => {
        const response = await getCustomFields(type, offset ? { ...params, offset } : params);

        response.data.data.forEach(field => fields.push(field));
        pagination = response.data.pagination;

        if (pagination.count === pagination.limit) {
            return await fetchFields(pagination.offset);
        }

        return fields;
    }

    return new Promise(async (resolve, reject) => {
        let allFields;
        await fetchFields(null).then((rows) => {
            allFields = rows;
        }).catch(reject);

        resolve(allFields);
    })
}

export {
    getCustomFields,
    getAllCustomFields
}